export const CUSTOM_LAYER_TYPE = 'CUSTOM';
export const CUSTOM_LAYER_FILL_OPACITY = 0.35;

export const DEFAULT_LAYER_WIDTH_FEET = 30;
